import { ContactType } from '@features/contacts/types/contactType'
import { ZervantContactType } from '@features/invoices/enums/zervantContactType'

const zervantToAgerasContactTypeMap: Partial<Record<ZervantContactType, ContactType>> = {
  [ZervantContactType.Company]: ContactType.Company,
  [ZervantContactType.Person]: ContactType.Person,
}

export const getAgerasContactType = (type?: ZervantContactType): ContactType =>
  zervantToAgerasContactTypeMap[type || ZervantContactType.Company] || ContactType.Company
